import React from "react";

export const SupportSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path fill="currentColor"
                  d="M11.1 56.83c.14.07.3.11.45.11.21 0 .42-.07.59-.19l8.07-5.85h28.6c3.99 0 7.24-3.25 7.24-7.25V30.04c-.63.39-1.3.72-2 .99v12.62c0 2.9-2.35 5.25-5.24 5.25H19.88c-.21 0-.42.07-.59.19l-6.74 4.89V49.9c0-.55-.45-1-1-1h-2.3A5.25 5.25 0 014 43.65V27.2c0-2.89 2.35-5.24 5.25-5.24h28.21c-.13-.65-.21-1.32-.23-2H9.25c-4 0-7.25 3.25-7.25 7.24v16.45c0 4 3.25 7.25 7.25 7.25h1.3v5.04a1 1 0 00.55.89z"/>
            <path fill="currentColor"
                  d="M37.568 28.417H9.98a1 1 0 000 2h27.588a1 1 0 000-2zM49.41 35.5a1 1 0 00-1-1H9.98a1 1 0 000 2h38.43a1 1 0 001-1zM9.98 40.582a1 1 0 000 2h29.019a1 1 0 000-2zM60 19.45c0-5.73-4.66-10.39-10.39-10.39s-10.4 4.66-10.4 10.39c0 .43.03.86.08 1.27.02.07.03.14.03.22v.02c.73 5.02 5.07 8.89 10.29 8.89 1.77 0 3.43-.44 4.88-1.22.02-.01.05-.03.07-.04A10.4 10.4 0 0060 19.45zm-6.9-3.53c.76 0 1.38.62 1.38 1.38 0 .77-.62 1.38-1.38 1.38-.77 0-1.39-.61-1.39-1.38 0-.76.62-1.38 1.39-1.38zm-6.98 0c.76 0 1.38.62 1.38 1.38 0 .77-.62 1.38-1.38 1.38s-1.38-.61-1.38-1.38c0-.76.62-1.38 1.38-1.38zm8.09 7.16a6.505 6.505 0 01-9.21 0c-.39-.39-.39-1.02 0-1.41s1.03-.39 1.42 0a4.515 4.515 0 006.38 0 .996.996 0 111.41 1.41z"/>
        </svg>
    )
}

